import React from 'react';
import styled from 'styled-components';
import {
  SYS_BREAKPOINT_2_XL,
  SYS_BREAKPOINT_LG,
  SYS_BREAKPOINT_MD,
  SYS_BREAKPOINT_SM,
  SYS_BREAKPOINT_XL,
  SYS_BREAKPOINT_XS,
  SYS_SPACE_RELATIVE_BP2_XL_2_XL,
  SYS_SPACE_RELATIVE_BP2_XL_4_XL,
  SYS_SPACE_RELATIVE_BP_LG_2_XL,
  SYS_SPACE_RELATIVE_BP_LG_4_XL,
  SYS_SPACE_RELATIVE_BP_MD_2_XL,
  SYS_SPACE_RELATIVE_BP_MD_4_XL,
  SYS_SPACE_RELATIVE_BP_SM_2_XL,
  SYS_SPACE_RELATIVE_BP_SM_4_XL,
  SYS_SPACE_RELATIVE_BP_XL_2_XL,
  SYS_SPACE_RELATIVE_BP_XL_4_XL,
  SYS_SPACE_RELATIVE_BP_XS_2_XL,
  SYS_SPACE_RELATIVE_BP_XS_4_XL,
  SYS_COLOR_SURFACE_NEUTRAL_300_LIGHT,
  SYS_SPACE_FIXED_200,
} from '@oneaudi/unified-web-common';
import { Popover, PopoverProps } from '@oneaudi/unified-web-components';

export const NextBestActionsContainer = styled.div`
  width: 100%;
  display: flex;
  justify-content: center; /* Center the whole grid group */
  padding: 1rem;
`;
export const NextBestActionsInnerContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, auto));
  @media (min-width: ${SYS_BREAKPOINT_XS}) {
    gap: ${SYS_SPACE_RELATIVE_BP_XS_2_XL};
    margin-bottom: ${SYS_SPACE_RELATIVE_BP_XS_4_XL};
    margin-top: ${SYS_SPACE_RELATIVE_BP_XS_4_XL};
  }
  @media (min-width: ${SYS_BREAKPOINT_SM}) {
    gap: ${SYS_SPACE_RELATIVE_BP_SM_2_XL};
    margin-bottom: ${SYS_SPACE_RELATIVE_BP_SM_4_XL};
    margin-top: ${SYS_SPACE_RELATIVE_BP_SM_4_XL};
  }
  @media (min-width: ${SYS_BREAKPOINT_MD}) {
    gap: ${SYS_SPACE_RELATIVE_BP_MD_2_XL};
    margin-bottom: ${SYS_SPACE_RELATIVE_BP_MD_4_XL};
    margin-top: ${SYS_SPACE_RELATIVE_BP_MD_4_XL};
  }
  @media (min-width: ${SYS_BREAKPOINT_LG}) {
    gap: ${SYS_SPACE_RELATIVE_BP_LG_2_XL};
    margin-bottom: ${SYS_SPACE_RELATIVE_BP_LG_4_XL};
    margin-top: ${SYS_SPACE_RELATIVE_BP_LG_4_XL};
  }
  @media (min-width: ${SYS_BREAKPOINT_XL}) {
    gap: ${SYS_SPACE_RELATIVE_BP_XL_2_XL};
    margin-bottom: ${SYS_SPACE_RELATIVE_BP_XL_4_XL};
    margin-top: ${SYS_SPACE_RELATIVE_BP_XL_4_XL};
  }
  @media (min-width: ${SYS_BREAKPOINT_2_XL}) {
    margin-bottom: ${SYS_SPACE_RELATIVE_BP2_XL_4_XL};
    margin-top: ${SYS_SPACE_RELATIVE_BP2_XL_4_XL};
    gap: ${SYS_SPACE_RELATIVE_BP2_XL_2_XL};
  }
  justify-content: start; /* Align items left inside the grid */
  max-width: 100%;
`;
export const NextBestActionsButtonContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  white-space: nowrap;
`;
export const TextWrapper = styled.div`
  margin: 0 3px;
`;
export const TextColorWrapper = styled.div`
  color: ${SYS_COLOR_SURFACE_NEUTRAL_300_LIGHT}};
`;
export const PopoverContentWrapper = styled.div<{ codeAndIconWidth: any }>`
  align-items: flex-start;
  display: flex;
  flex-direction: column;
  max-width: ${(props): any => (props.codeAndIconWidth ? `${props.codeAndIconWidth}px` : 'unset')};
`;
export const CodeAndIconWrapper = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: ${SYS_SPACE_FIXED_200};
`;
export const StyledPopover = styled((props) => <Popover {...props} />)<PopoverProps>`
  display: flex;
  align-items: center;
  margin-bottom: ${SYS_SPACE_FIXED_200};
`;
